export default function handleRejectMRole(params) {
  const tidRaw = params.get("tid") || "";
  const assignerIdRaw = params.get("assignerId") || "";
  const keyword = params.get("keyword") || "";
  const emailIdRaw = params.get("emailId") || "";

  let emailId = "";

  try {
    emailId = emailIdRaw
      ? decodeURIComponent(atob(emailIdRaw))
      : "";
  } catch (error) {
    emailId = "";
  }

  const tid = tidRaw ? Number(tidRaw.replace(/,/g, "")) : null;
  const assignerId = assignerIdRaw
    ? Number(assignerIdRaw.replace(/,/g, ""))
    : null;

  return {
    action: "rejectMRole",
    tid,
    assignerId,
    keyword,
    emailId,
  };
}